import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a1651e14"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "header-title w-100 text-center"
}
const _hoisted_2 = {
  key: 1,
  class: "flex-grow-1"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { style: {"font-weight":"500 !important"} }, "Fotos auswählen & drucken", -1))
const _hoisted_4 = {
  key: 2,
  class: "d-flex align-items-center"
}
const _hoisted_5 = { class: "d-flex" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Auswahl verwerfen ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-trash3",
  style: {"margin-left":"1rem","font-size":"1.5rem"}
}, null, -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Drucken ")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-printer",
  style: {"margin-left":"1rem","font-size":"1.5rem"}
}, null, -1))
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]


import theme from "@/theme";


export default /*#__PURE__*/_defineComponent({
  props: {
  selectionMode: {
    type: Boolean
  },
  selectionAmount: {
    type: Number
  }
},
  emits: ["adminMenuToggled", "printTriggered", "discardSelectionTriggered"],
  setup(__props, { emit }: { emit: ({
  (e: 'adminMenuToggled'):void
  (e: 'printTriggered'):void
  (e: 'discardSelectionTriggered'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props






let clicks = 0
let clickReset = -1

const handleAdminMenuToggleClick = () => {
  clicks++
  if (clickReset == -1) {
    clickReset = setTimeout(() =>{
      clicks = 0
      clickReset = -1
    }, 2000)
  }
  if (clicks >= 5) {
    emit('adminMenuToggled')
    console.log("Admin toggled")
    clicks = 0
    clearTimeout(clickReset)
    clickReset = -1
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "container-gallery-header",
    class: _normalizeClass(["d-flex align-items-center w-100 bg-greeny", {'shrink':!__props.selectionMode}]),
    onClick: handleAdminMenuToggleClick
  }, [
    (!__props.selectionMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(theme).title), 1))
      : _createCommentVNode("", true),
    (__props.selectionMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", null, [
            _createElementVNode("h2", null, _toDisplayString(__props.selectionAmount) + " | 3 ausgewählt", 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.selectionMode)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "button-greeny",
              style: {"margin-right":"1.5rem"},
              onClick: _cache[0] || (_cache[0] = (e) => {emit('discardSelectionTriggered'); e.stopPropagation()})
            }, _hoisted_8),
            _createElementVNode("button", {
              class: "button-primary",
              onClick: _cache[1] || (_cache[1] = (e) => {emit('printTriggered'); e.stopPropagation()})
            }, _hoisted_11)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})